var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoctor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 36.5699V41H7V36.5699C7 35.1746 8.06434 33.603 10.0628 32.1449C11.9322 30.781 14.4166 29.6732 16.8967 29.0646C16.9081 29.0851 16.9201 29.1075 16.9329 29.1318C16.9604 29.1842 16.9875 29.2382 17.0182 29.2993L17.0219 29.3067C17.0501 29.3628 17.0825 29.4276 17.1151 29.4896L17.3963 30.0237H18H22.0639H22.0642C22.9856 30.0235 23.435 30.0236 23.89 30.0237C24.3346 30.0238 24.7845 30.0239 25.6851 30.0237C25.6852 30.0237 25.6852 30.0237 25.6853 30.0237H29.7493H30.3529L30.6341 29.4896C30.7147 29.3365 30.8425 29.1512 30.965 29.0333C30.9656 29.0327 30.9662 29.0322 30.9667 29.0316C33.492 29.6326 36.0335 30.756 37.9372 32.1449C39.9357 33.603 41 35.1746 41 36.5699ZM16.7834 28.8881C16.782 28.8867 16.7813 28.8859 16.7813 28.8859C16.7813 28.8858 16.782 28.8865 16.7834 28.8881Z",
    stroke: "#333333",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 37.0147C16.5384 37.0147 17 36.5742 17 36C17 35.4258 16.5384 34.9853 16 34.9853C15.4616 34.9853 15 35.4258 15 36C15 36.5742 15.4616 37.0147 16 37.0147ZM16 39C17.6569 39 19 37.6569 19 36C19 34.3431 17.6569 33 16 33C14.3431 33 13 34.3431 13 36C13 37.6569 14.3431 39 16 39Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 38H30V36L31 34H35L36 36V38H34",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34C33.5 33.3333 34 30.5 33.5 29.5",
    stroke: "#333333",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7072 34C15.2072 33.3333 14.7072 30.5 15.2072 29.5",
    stroke: "#333333",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33 16C33 20.9727 28.9727 25 24 25C19.0273 25 15 20.9727 15 16C15 11.0273 19.0273 7 24 7C28.9727 7 33 11.0273 33 16Z",
    stroke: "#333333",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/doctor.90726c7fdb95bcc0ecafb47e2bc3d6a7.svg";
export { ForwardRef as ReactComponent };